// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1164":"65e537bb","2589":"d6fdf0fb","3071":"54245876"}[chunkId] + ".css";
};